// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 20V18H22V20H12ZM12 13V11L22 11V13L12 13ZM12 6V4H22V6H12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 10L2 2L10 2V10H2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22L2 14H10V22H2Z"}}]};

const TreeCatalogFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-catalog-filled',
    ref,
    icon: element,
  },
));

TreeCatalogFilledIcon.displayName = 'TreeCatalogFilledIcon';

export default TreeCatalogFilledIcon;
